/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit'
import * as API from 'api'
import { ScheduledReport } from './types'

export const getDashboardAlerts = createAsyncThunk(
  'scheduledReport/getDashboardAlerts',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await API.getDashboardAlerts(id)
      return data
    } catch (err: unknown) {
      return rejectWithValue((err as any)?.response?.data)
    }
  }
)

export const subscribeDashboardAlerts = createAsyncThunk(
  'scheduledReport/subscribeDashboardAlerts',
  async (id: number, { rejectWithValue }) => {
    try {
      const { data } = await API.subscribeDashboardAlerts(id)
      return data
    } catch (err: unknown) {
      return rejectWithValue((err as any)?.response?.data)
    }
  }
)

export const unsubscribeDashboardAlerts = createAsyncThunk(
  'scheduledReport/unsubscribeDashboardAlerts',
  async (id: number, { rejectWithValue }) => {
    try {
      const { data } = await API.unsubscribeDashboardAlerts(id)
      return data
    } catch (err: unknown) {
      return rejectWithValue((err as any)?.response?.data)
    }
  }
)

export const createUpdateScheduledReport = createAsyncThunk(
  'scheduledReport/createUpdateScheduledReport',
  async (
    { id, reportConfig }: { id: number; reportConfig: ScheduledReport },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await API.createUpdateScheduledReport(id, reportConfig)
      return data
    } catch (err: unknown) {
      return rejectWithValue((err as any)?.response?.data)
    }
  }
)

export const deleteScheduledReport = createAsyncThunk(
  'scheduledReport/deleteScheduledReport',
  async (id: number, { rejectWithValue }) => {
    try {
      const { data } = await API.deleteScheduledReport(id)
      return data
    } catch (err: unknown) {
      return rejectWithValue((err as any)?.response?.data)
    }
  }
)

export const getDashboardNameBySubscriptionUuId = createAsyncThunk(
  'scheduledReport/getDashboardNameBySubscriptionUuId',
  async (id: number | string, { rejectWithValue }) => {
    try {
      const { data } = await API.getDashboardNameBySubscriptionUuId(id)
      return data
    } catch (err: unknown) {
      return rejectWithValue((err as any)?.response?.data)
    }
  }
)

export const unsubscribeDashboardBySubscriptionUuId = createAsyncThunk(
  'scheduledReport/unsubscribeDashboardBySubscriptionUuId',
  async (id: number | string, { rejectWithValue }) => {
    try {
      const { data } = await API.unsubscribeDashboardBySubscriptionUuId(id)
      return data
    } catch (err: unknown) {
      return rejectWithValue((err as any)?.response?.data)
    }
  }
)
